class MiniCart extends HTMLElement {
  constructor() {
    super();

    //add event listeners
    this.addListeners();

    //event listeners
    document.addEventListener(
      "mini-cart-open",
      this.handleMiniCartTrigger.bind(this)
    );

    document.addEventListener("mini-cart-refresh", () => {
      this.renderCart();
    });
  }

  handleMiniCartTrigger() {
    this.renderCart();

    document
      .getElementById("drawer-mini-cart")
      .dispatchEvent(new Event("drawer-toggle"));
  }

  //quantity input change
  handleInputChange(input) {
    this.classList.add("loading");
    let lineKey = input.getAttribute("data-key");
    let quantity = parseInt(input.value);

    if (lineKey && quantity >= 0) {
      const body = JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: "stmt-mini-cart",
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          hamperCheck();
          let sectionHtml = JSON.parse(text).sections["stmt-mini-cart"];
          this.renderCart(sectionHtml);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      this.classList.remove("loading");
      console.error("No line item details");
    }
  }

  //remove item
  removeItem(remove) {
    this.classList.add("loading");
    let lineKey = remove.getAttribute("data-key");

    if (lineKey) {
      const body = JSON.stringify({
        id: lineKey,
        quantity: 0,
        sections: "stmt-mini-cart",
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          hamperCheck();
          let sectionHtml = JSON.parse(text).sections["stmt-mini-cart"];
          this.renderCart(sectionHtml);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      this.classList.remove("loading");
      console.error("No line item details");
    }
  }

  renderCart(html) {
    this.classList.add("loading");

    if (html) {
      //insert cart items
      this.querySelector(".js-mini-cart-items").innerHTML = html;

      //add event listeners
      this.addListeners();

      //update elements
      updateElements();
    } else {
      fetch("/?section_id=stmt-mini-cart")
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          //insert cart items
          this.querySelector(".js-mini-cart-items").innerHTML = response;

          //add event listeners
          this.addListeners();

          //update elements
          updateElements();
        });
    }

    document.dispatchEvent(new Event("check-cart"));
  }

  addListeners() {
    //get form elements and add event listeners
    this.miniCartForm = this.querySelector("form");
    this.quantityInputs = this.miniCartForm.querySelectorAll(
      ".js-mini-cart-quantity"
    );
    this.quantityInputs.forEach((input) =>
      input.addEventListener("change", this.handleInputChange.bind(this, input))
    );

    this.removeButtons = this.miniCartForm.querySelectorAll(
      ".js-mini-cart-item__remove"
    );
    this.removeButtons.forEach((remove) =>
      remove.addEventListener("click", this.removeItem.bind(this, remove))
    );
  }
}

customElements.define("mini-cart", MiniCart);
